import { render, staticRenderFns } from "./thread-form-group.vue?vue&type=template&id=415da7c0&scoped=true&"
import script from "./thread-form-group.vue?vue&type=script&lang=js&"
export * from "./thread-form-group.vue?vue&type=script&lang=js&"
import style0 from "./thread-form-group.vue?vue&type=style&index=0&id=415da7c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415da7c0",
  null
  
)

component.options.__file = "thread-form-group.vue"
export default component.exports